import React, { Component } from "react";

import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addLegalEntity } from "../../../../store/actions";
import LegalEntityInformationForm from "./components/LegalEntityInformationForm";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

class AddLegalEntity extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Add legal entity | Mobihunter" />
          <Container fluid>
            <Breadcrumbs
              title="Contractors"
              breadcrumbItem="Add contractor"
              link="/legal-entity"
            />
            <LegalEntityInformationForm
              legalEntityData={this.props.legalEntityData}
              history={this.props.history}
              addLegalEntity={this.props.addLegalEntity}
              permissions={this.props.permissions}
              data={{}}
              loader={false}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddLegalEntity.propTypes = {
  legalEntityData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  addLegalEntity: PropTypes.func.isRequired,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  legalEntityData: state.LegalEntityList.data,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  addLegalEntity,
})(AddLegalEntity);
